import {
  computed,
  ref
} from 'vue'

const showing = ref(true)

export const usePropertySearchBox = () => {
  const showingPropertySearchBox = computed(() => showing.value)

  const hidePropertySearchBox = () => showing.value = false
  const showPropertySearchBox = () => showing.value = true

  return {
    showingPropertySearchBox,
    hidePropertySearchBox,
    showPropertySearchBox,
  }
}
